import api from './api';

const paymentService = {
  // Create Stripe Payment
  createStripePayment: async (appointmentId, amount) => {
    try {
      const response = await api.post('/payments/stripe/create', {
        appointmentId,
        amount,
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Create Razorpay Order
  createRazorpayOrder: async (appointmentId, amount) => {
    try {
      const response = await api.post('/payments/razorpay/create', {
        appointmentId,
        amount,
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Verify Stripe Payment
  verifyStripePayment: async (paymentIntentId, paymentId) => {
    try {
      const response = await api.post('/payments/stripe/verify', {
        paymentIntentId,
        paymentId,
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Verify Razorpay Payment
  verifyRazorpayPayment: async (paymentData) => {
    try {
      const response = await api.post('/payments/razorpay/verify', paymentData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Get User Payments
  getUserPayments: async () => {
    try {
      const response = await api.get('/payments/user');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Get Payment by ID
  getPaymentById: async (paymentId) => {
    try {
      const response = await api.get(`/payments/${paymentId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Load Razorpay Script
  loadRazorpayScript: () => {
    return new Promise((resolve) => {
      const script = document.createElement('script');
      script.src = 'https://checkout.razorpay.com/v1/checkout.js';
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  },

  // Load Stripe
  loadStripe: async (stripeKey) => {
    if (window.Stripe) {
      return window.Stripe(stripeKey);
    }
    
    const script = document.createElement('script');
    script.src = 'https://js.stripe.com/v3/';
    
    return new Promise((resolve, reject) => {
      script.onload = () => {
        if (window.Stripe) {
          resolve(window.Stripe(stripeKey));
        } else {
          reject(new Error('Stripe failed to load'));
        }
      };
      script.onerror = () => reject(new Error('Failed to load Stripe script'));
      document.head.appendChild(script);
    });
  },
};

export default paymentService;
